document.addEventListener('DOMContentLoaded', function() {
    iniciarApp();
})

function iniciarApp() {
    insertarGaleria();
    navegacionFija();
    scrollNav();
}

//barra de navegacion fija
function navegacionFija() {
    const barra = document.querySelector('.header');
    const sobreFestival = document.querySelector('.sobre-festival');
    const body = document.querySelector('body')

    window.addEventListener('scroll', function() {

        if (sobreFestival.getBoundingClientRect().top < 0) {
            barra.classList.add('barra-fija');
            body.classList.add('body-scroll');
        } else {
            barra.classList.remove('barra-fija');
            body.classList.remove('body-scroll');
        }
    })
}

//Funcionalidad a los enlaces de la barra
function scrollNav() {
    const enlaces = document.querySelectorAll('.navegacion-principal a');

    enlaces.forEach(enlace => {
        enlace.addEventListener('click', function(e) {
            e.preventDefault();

            const seccionScroll = e.target.attributes.href.value;
            const seccion = document.querySelector(seccionScroll);
            seccion.scrollIntoView({ behavior: "smooth" });
        })
    });
}

//insertar imagenes a la galeria
function insertarGaleria() {
    const galeria = document.querySelector('.galeria-imagenes');
    for (let i = 1; i <= 12; i++) {
        const imagen = document.createElement('picture');

        imagen.innerHTML = `
            <source srcset="build/img/thumb/${i}.avif" type="image/avif">
            <source srcset="build/img/thumb/${i}.webp" type="image/webp">
            <img loading="lazy" width="200" height="300" src="build/img/thumb/${i}.jpg" alt="Imagen galeria">
        `;
        imagen.onclick = function() { //Para pasarle parametros lo tenemos que hace ccoo call back
            mostrarImagen(i);
        }

        //mostrar la galeria
        galeria.appendChild(imagen);
    }

    function mostrarImagen(id) {
        const imagen = document.createElement('PICTURE');
        imagen.innerHTML = `
        <source srcset="build/img/grande/${id}.avif" type="image/avif">
        <source srcset="build/img/grande/${id}.webp" type="image/webp">
        <img loading="lazy" width="200" height="300" src="build/img/grande/${id}.jpg" alt="Imagen galeria">
    `;

        //overlay
        const overlay = document.createElement('DIV');
        overlay.appendChild(imagen);
        overlay.classList.add('overlay');
        overlay.onclick = function() {
            const body = document.querySelector('body');
            body.classList.remove('fijar-body');
            overlay.remove();
        }

        //boton para cerrar la ventana modal
        const cerrarModal = document.createElement('BODY');
        cerrarModal.textContent = 'X';
        cerrarModal.classList.add('btn-cerrar');
        cerrarModal.onclick = function() {
            const body = document.querySelector('body');
            body.classList.remove('fijar-body');
            overlay.remove();
        }

        overlay.appendChild(cerrarModal);

        //mostrar la imagen grande
        const body = document.querySelector('body');
        body.appendChild(overlay);
        body.classList.add('fijar-body');
    }

}